import React, { useState } from "react";
import logo from "../../Assets/logo.png";
import "./home.css";
import ContentWrapper from "../Contents/ContentWrapper/ContentWrapper";
import contents from "../Contents/content";
import Footer from "../Footer/Footer";
import ChatBot from "../ChatBot/Chatbot";

export default function Home() {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const openChatBot = () => {
    setIsChatOpen(true);
  };


  return (
    <section className="HomeOuterBorder">
      <section className="headerWrapper">
        <img className="logo" src={logo} alt="sampurna-logo" />
        <div>
          <p className="PageTitle">Central Link Portal</p>
        </div>
      </section>
      <section className="contentBodyWrapper">
        {contents.map((cont) => {
          return (
            <ContentWrapper
              key={cont.id}
              category={cont.category}
              content={cont.content}
              openChatWindow={openChatBot}
            />
          );
        })}
      </section>
      <Footer />
      <ChatBot
        openChatBot={isChatOpen}
        handleChatBot={(value) => setIsChatOpen(value)}
      />
    </section>
  );
}
